import PatientMonitoring from "./PatientMonitoring";

export default PatientMonitoring;
